export const mockAI = {
  generatePitch: async (project) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(`Her er en generert pitch for ${project.name}:\n\n"Oppdag fremtiden med ${project.name}. Vi hjelper ${project.target_segment || 'bedrifter'} med å realisere sitt fulle potensial gjennom skreddersydde løsninger. Vår unike tilnærming sikrer høy ROI og sømløs integrasjon."`);
      }, 1500);
    });
  },
  generateBattlecards: async (project) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const competitors = [
          { competitor: "Konkurrent A", strengths: "Lav pris, bred distribusjon", weaknesses: "Manglende support, utdatert teknologi", our_edge: "Vi tilbyr 24/7 support og markedsledende AI-teknologi." },
          { competitor: "Konkurrent B", strengths: "Sterk merkevare", weaknesses: "Lite fleksibel løsning", our_edge: "Vår løsning er 100% tilpassbar til kundens behov." }
        ];
        resolve(competitors);
      }, 1500);
    });
  },
  suggestNextActions: async (deal, stageName) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const suggestions = [
          `Send en oppfølgingsmail med referanseprosjekter relevant for ${deal.title}.`,
          `Inviter beslutningstaker til en dedikert demo-sesjon.`,
          `Utarbeid et utkast til ROI-kalkyle basert på verdi: ${deal.value} NOK.`
        ];
        resolve(suggestions.join('\n- '));
      }, 1200);
    });
  },
  generateSocialPost: async (project, channel) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const hashtags = project.type === 'Tjeneste' ? '#Service #Innovation' : '#NewProduct #Launch';
        resolve(`🚀 Spennende nyheter fra ${project.department}!\n\nVi jobber hardt med ${project.name} for å gi våre kunder den beste opplevelsen. \n\nEr du klar for å ta bedriften til neste nivå?\n\n${hashtags} #BusinessGrowth`);
      }, 1500);
    });
  },
  // NEW: Lead Intelligence
  analyzeSignal: async (signal, context) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const analysis = {
          next_step: "Ta kontakt med CTO eller IT-sjef.",
          outreach_text: `Hei, så nyheten om ${signal.title.toLowerCase()}. Ser dere satser stort nå – hvordan påvirker dette teknologistacken deres?`,
          scenario: "Vekst/Ekspansjon",
          risk: "Unngå å virke opportunistisk. Fokuser på verdi, ikke salg."
        };
        resolve(analysis);
      }, 1500);
    });
  }
};